(function (globalScop) {

  const environmentDetectionRegex = {
  local: [/localhost:4200/i, /localhost:7001/i, /localhost:9876/i],
  pcfDev: [/hipp-portal-ui\.apps\.pcfdev\.hms\.hmsy\.com/i],
  pieronlineDev: [/hippportaldev\.hms\.com/i],
  pcfUat: [/hipp-portal-ui\.apps\.pcfuat\.hms\.hmsy\.com/i],
  pieronlineUat: [/hippportaluat\.hms\.com/i],
  pcfTest: [/hipp-portal-ui\.apps\.pcftest\.hms\.hmsy\.com/i],
  pieronlineTest: [/hippportaltest\.hms\.com/i],
  pcfProd: [/hipp-portal-ui\.apps\.pcfprod\.hms\.hmsy\.com/i],
  pieronlineProd: [/hippportal\.hms\.com/i]
  };

  const allConfigs = {
  local: {
    isLocal: true,
    PIERHIPPLAapiUrl: 'http://localhost:8080/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'http://localhost:8080/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl: 'http://localhost:8080/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'http://localhost:8080/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'http://localhost:8080/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'http://localhost:8080/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'http://localhost:8080/pierhibico/noAuth/pierOnline',
    PIERHIPPGAapiUrl: 'http://localhost:8080/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'http://localhost:8080/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'http://localhost:8080/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'http://localhost:8080/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'http://localhost:8080/pierhippdemo/noAuth/pierOnline',
    validateAddresses: true,
    smartyKey: '201779659199153571',
      },

  pcfDev: {
    isLocal: false,
    PIERHIPPLAapiUrl: 'https://hipp-pierhippla-api.apps.pcfdev.hms.hmsy.com/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'https://hipp-pierhippak-api.apps.pcfdev.hms.hmsy.com/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl: 'https://hipp-pierhippnv-api.apps.pcfdev.hms.hmsy.com/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'https://hipp-pierhippal-api.apps.pcfdev.hms.hmsy.com/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'https://hipp-pierhippar-api.apps.pcfdev.hms.hmsy.com/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'https://hipp-pierhippnc-api.apps.pcfdev.hms.hmsy.com/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'https://hipp-pierhibico-api.apps.pcfdev.hms.hmsy.com/pierhibico/noAuth/pierOnline',
    PIERHIPPGAapiUrl: 'https://hipp-pierhippga-api.apps.pcfdev.hms.hmsy.com/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'https://hipp-pierhippfl-api.apps.pcfdev.hms.hmsy.com/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'https://hipp-pierchipraga-api.apps.pcfdev.hms.hmsy.com/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'https://hipp-pierhippwv-api.apps.pcfdev.hms.hmsy.com/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'https://hipp-pierhippdemo-api.apps.pcfdev.hms.hmsy.com/pierhippdemo/noAuth/pierOnline',
    validateAddresses:  false,
	  smartyKey: '201779660583185961pcfdev',
     },

  pieronlineDev: {
    isLocal: false,
    PIERHIPPLAapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhibico/noAuth/pierOnline',
    PIERHIPPGAapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'https://apigatewayintdev.hms.hmsy.com/pierhippdemo/noAuth/pierOnline',
    validateAddresses: true,
	  smartyKey: '201779660583185961',
  },

  pcfTest: {
    isLocal: false,
    PIERHIPPLAapiUrl: 'https://hipp-pierhippla-api.apps.pcftest.hms.hmsy.com/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'https://hipp-pierhippak-api.apps.pcftest.hms.hmsy.com/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl:  'https://hipp-pierhippnv-api.apps.pcftest.hms.hmsy.com/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'https://hipp-pierhippal-api.apps.pcftest.hms.hmsy.com/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'https://hipp-pierhippar-api.apps.pcftest.hms.hmsy.com/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'https://hipp-pierhippnc-api.apps.pcftest.hms.hmsy.com/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'https://hipp-pierhibico-api.apps.pcftest.hms.hmsy.com/pierhibico/noAuth/pierOnline',
    PIERHIPPGAapiUrl: 'https://hipp-pierhippga-api.apps.pcftest.hms.hmsy.com/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'https://hipp-pierhippfl-api.apps.pcftest.hms.hmsy.com/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'https://hipp-pierchipraga-api.apps.pcftest.hms.hmsy.com/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'https://hipp-pierhippwv-api.apps.pcftest.hms.hmsy.com/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'https://hipp-pierhippdemo-api.apps.pcftest.hms.hmsy.com/pierhippdemo/noAuth/pierOnline',
    validateAddresses: false,
	  smartyKey: '201779660583185961',
    },
  
  pieronlineTest: {
    isLocal: false,
    PIERHIPPLAapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhibico/noAuth/pierOnline',    
    PIERHIPPGAapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'https://apigatewayinttest.hms.hmsy.com/pierhippdemo/noAuth/pierOnline',
    validateAddresses: true,
	  smartyKey: '201779660276582564',
  },

  pcfUat: {
    PIERHIPPLAapiUrl: 'https://hipp-portal-api.apps.pcfuat.hms.hmsy.com/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'https://hipp-pierhippak-api.apps.pcfuat.hms.hmsy.com/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl: 'https://hipp-pierhippnv-api.apps.pcfuat.hms.hmsy.com/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'https://hipp-pierhippal-api.apps.pcfuat.hms.hmsy.com/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'https://hipp-pierhippar-api.apps.pcfuat.hms.hmsy.com/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'https://hipp-pierhippnc-api.apps.pcfuat.hms.hmsy.com/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'https://hipp-pierhibico-api.apps.pcfuat.hms.hmsy.com/pierhibico/noAuth/pierOnline',
    PIERHIPPGAapiUrl: 'https://hipp-pierhippga-api.apps.pcfuat.hms.hmsy.com/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'https://hipp-pierhippfl-api.apps.pcfuat.hms.hmsy.com/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'https://hipp-pierchipraga-api.apps.pcfuat.hms.hmsy.com/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'https://hipp-pierhippwv-api.apps.pcfuat.hms.hmsy.com/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'https://hipp-pierhippdemo-api.apps.pcfuat.hms.hmsy.com/pierhippdemo/noAuth/pierOnline',
    validateAddresses: true,
    smartyKey: '201779660497744487',
         },

  pieronlineUat: {
    PIERHIPPLAapiUrl: 'https://apigatewayextuat.hms.com/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'https://apigatewayextuat.hms.com/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl: 'https://apigatewayextuat.hms.com/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'https://apigatewayextuat.hms.com/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'https://apigatewayextuat.hms.com/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'https://apigatewayextuat.hms.com/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'https://apigatewayextuat.hms.com/pierhibico/noAuth/pierOnline',    
    PIERHIPPGAapiUrl: 'https://apigatewayextuat.hms.com/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'https://apigatewayextuat.hms.com/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'https://apigatewayextuat.hms.com/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'https://apigatewayextuat.hms.com/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'https://apigatewayextuat.hms.com/pierhippdemo/noAuth/pierOnline',
    validateAddresses: true,
    smartyKey: '201779660497744487',
         },

  pcfProd: {
    isLocal: false,
    PIERHIPPLAapiUrl: 'https://hipp-pierhippla-api.apps.pcfprod.hms.hmsy.com/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'https://hipp-pierhippak-api.apps.pcfprod.hms.hmsy.com/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl:  'https://hipp-pierhippnv-api.apps.pcfprod.hms.hmsy.com/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'https://hipp-pierhippal-api.apps.pcfprod.hms.hmsy.com/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'https://hipp-pierhippar-api.apps.pcfprod.hms.hmsy.com/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'https://hipp-pierhippnc-api.apps.pcfprod.hms.hmsy.com/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'https://hipp-pierhibico-api.apps.pcfprod.hms.hmsy.com/pierhibico/noAuth/pierOnline',
    PIERHIPPGAapiUrl: 'https://hipp-pierhippga-api.apps.pcfprod.hms.hmsy.com/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'https://hipp-pierhippfl-api.apps.pcfprod.hms.hmsy.com/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'https://hipp-pierchipraga-api.apps.pcfprod.hms.hmsy.com/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'https://hipp-pierhippwv-api.apps.pcfprod.hms.hmsy.com/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'https://hipp-pierhippdemo-api.apps.pcfprod.hms.hmsy.com/pierhippdemo/noAuth/pierOnline',
    validateAddresses: true,
    smartyKey: '201779660993184604',
   },

  pieronlineProd: {
    isLocal: false,
    PIERHIPPLAapiUrl: 'https://apigatewayext.hms.com/pierhippla/noAuth/pierOnline',
    PIERHIPPAKapiUrl: 'https://apigatewayext.hms.com/pierhippak/noAuth/pierOnline',
    PIERHIPPNVapiUrl:  'https://apigatewayext.hms.com/pierhippnv/noAuth/pierOnline',
    PIERHIPPALapiUrl: 'https://apigatewayext.hms.com/pierhippal/noAuth/pierOnline',
    PIERHIPPARapiUrl: 'https://apigatewayext.hms.com/pierhippar/noAuth/pierOnline',
    PIERHIPPNCapiUrl: 'https://apigatewayext.hms.com/pierhippnc/noAuth/pierOnline',
    PIERHIBICOapiUrl: 'https://apigatewayext.hms.com/pierhibico/noAuth/pierOnline',
    PIERHIPPGAapiUrl: 'https://apigatewayext.hms.com/pierhippga/noAuth/pierOnline',
    PIERHIPPFLapiUrl: 'https://apigatewayext.hms.com/pierhippfl/noAuth/pierOnline',
    PIERCHIPRAGAapiUrl: 'https://apigatewayext.hms.com/pierchipraga/noAuth/pierOnline',
    PIERHIPPWVapiUrl: 'https://apigatewayext.hms.com/pierhippwv/noAuth/pierOnline',
    PIERHIPPDEMOapiUrl: 'https://apigatewayext.hms.com/pierhippdemo/noAuth/pierOnline',
    validateAddresses: true,
    smartyKey: '201779660993184604',
     },

  };

  function getCurrentenvironment() {
      const environment = Object.getOwnPropertyNames(environmentDetectionRegex).filter(function (propName) {
          const regexes = environmentDetectionRegex[propName];
          return regexes.some(function (value) {
              return value.test(window.location.host);
          });
      })[0];
      if (!environment) {
          throw new Error('Application is not configured for this URL, please contact admin.')
      }
      return environment;
  }

  const environment = getCurrentenvironment();
  globalScop.appConfigs = {
      environment: environment,
      isLocal: allConfigs[environment].isLocal,
      PIERHIPPLAapiUrl: allConfigs[environment].PIERHIPPLAapiUrl,
      PIERHIPPAKapiUrl: allConfigs[environment].PIERHIPPAKapiUrl,
      PIERHIPPNVapiUrl: allConfigs[environment].PIERHIPPNVapiUrl,
      PIERHIPPALapiUrl: allConfigs[environment].PIERHIPPALapiUrl,
      PIERHIPPARapiUrl: allConfigs[environment].PIERHIPPARapiUrl,
      PIERHIPPNCapiUrl: allConfigs[environment].PIERHIPPNCapiUrl,
      PIERHIBICOapiUrl: allConfigs[environment].PIERHIBICOapiUrl,
      PIERHIPPGAapiUrl: allConfigs[environment].PIERHIPPGAapiUrl,
      PIERHIPPFLapiUrl: allConfigs[environment].PIERHIPPFLapiUrl,
      PIERCHIPRAGAapiUrl: allConfigs[environment].PIERCHIPRAGAapiUrl,
      PIERHIPPWVapiUrl: allConfigs[environment].PIERHIPPWVapiUrl,
      PIERHIPPDEMOapiUrl: allConfigs[environment].PIERHIPPDEMOapiUrl,
      validateAddresses:allConfigs[environment].validateAddresses,
      smartyKey: allConfigs[environment].smartyKey,
  };
})(this);
